import { useEffect, useState } from 'react';

declare global {
  interface Window {
    snowplow: (
      callback: (this: { atrck: { getDomainUserInfo: () => string[] } }) => void
    ) => string;
  }
}

export default function useSnowplowSessionId(): string | undefined {
  const [sessionId, setSessionId] = useState<string | undefined>();

  useEffect(() => {
    // if (typeof window !== 'undefined' && window.snowplow) {
    // window.snowplow(function getSnowplowSessionId() {
    //   setSessionId(this.atrck.getDomainUserInfo()[6]);
    // });
    setSessionId('temp-snowplow-session-id');
    // }
  }, []);

  return sessionId;
}
